import { NgModule } from '@angular/core';
import { HybridizerComponent } from './hybridizer.component';

@NgModule({
  declarations: [HybridizerComponent],
  entryComponents: [HybridizerComponent],
  exports: [HybridizerComponent]
})
export class HybridizerModule { }
